export class CategoryForm {
    public UserPNumber : string;
    public CategoryID : number;
    public Description : string;
    public Active : string;
}
